export default "__VITE_ASSET__CQXMoLRl__"